<div class="client_trader_edit__container" fxLayout="column">
  <div class="client_trader_edit__fields bfx-section-wrapper" fxFlex="100%">
    <span>
      <label for="client">Client</label>
      <bfx-text-input
        id="client"
        type="search"
        size="sm"
        [(ngModel)]="client.clientName"
        [maxlength]="50"
        [disabled]="true"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="user-name">Client Trader Name</label>
      <bfx-text-input
        id="user-name"
        [ngClass]="{'valid': valid[1]==1, 'invalid': valid[1]==2}"
        (blur)="validate(1)"
        type="search"
        size="sm"
        [(ngModel)]="clientTrader.userName"
        [maxlength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="comment">Client Trader Comment</label>
      <textarea
        id="comment"
        class="comment"
        [ngClass]="{'valid': valid[2]==1, 'invalid': valid[2]==2, 'populated': clientTrader.comment!=null && clientTrader.comment.length > 0}"
        (blur)="validate(2)"
        type="search"
        pInputTextArea
        [(ngModel)]="clientTrader.comment"
        [maxlength]="250"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></textarea>
    </span>
    <span>
      <label for="desk">Desk</label>
      <bfx-text-input
        id="desk"
        [ngClass]="{'valid': valid[3]==1, 'invalid': valid[3]==2}"
        (blur)="validate(3)"
        type="search"
        size="sm"
        [(ngModel)]="clientTrader.desk"
        [maxlength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="mobile">Mobile</label>
      <bfx-text-input
        id="mobile"
        [ngClass]="{'valid': valid[4]==1, 'invalid': valid[4]==2}"
        (blur)="validate(4)"
        type="search"
        size="sm"
        [(ngModel)]="clientTrader.smsNumber"
        [maxlength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="email">Email</label>
      <bfx-text-input
        id="email"
        [ngClass]="{'valid': valid[5]==1, 'invalid': valid[5]==2}"
        (blur)="validate(5)"
        type="search"
        size="sm"
        [(ngModel)]="clientTrader.emailAddress"
        [maxlength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <p-checkbox
        [ngClass]="{'valid': clientTrader.isDefault}"
        [binary]="true"
        class="bfx-checkbox-bold-sm"
        [disabled]="locked"
        label="Default Client Trader"
        [(ngModel)]="clientTrader.isDefault"
      ></p-checkbox>
    </span>
    <span> </span>
  </div>
  <div class="divider"></div>
  <div class="btn-bar">
    <button class="bfx-button-negative" (click)="cancel()">Cancel</button>
    <button class="bfx-button-primary" [disabled]="!isSaveEnabled()" (click)="save()">Save</button>
  </div>
</div>
